import { PerceivedProvisioningStartTimer } from '../../utils/perceived-provisioning/perceived-provisioning-start-timer';
import { twcScreenConfig } from '../../utils/screen-manager/twc-screen-config';
import { twcScreenDictionary } from '../../utils/screen-manager/twc-screen-dictionary';
import { TwcProvisioningScreen } from '../twc-provisioning-screen/twc-provisioning-screen';

import { BaseProvisioningUI } from './base-provisioning-ui';

/**
 * Component that shows default provisioning UI.
 * @returns @type {JSX.Element}
 */
export const TeamWorkCollectionProvisioningUI = () => {
	return (
		<BaseProvisioningUI
			screenConfig={twcScreenConfig}
			screenDictionary={twcScreenDictionary}
			screenFallback={
				<PerceivedProvisioningStartTimer>
					<TwcProvisioningScreen />
				</PerceivedProvisioningStartTimer>
			}
		/>
	);
};
